export default "__VITE_ASSET__a9e388d6__"